"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoEffect = void 0;
const pixi_js_1 = require("pixi.js");
const ParticleEmitter_1 = require("../ParticleEmitter");
const InfoSprite_1 = require("./InfoSprite");
const Utils_1 = require("../../Utils/Utils");
class InfoEffect extends pixi_js_1.Container {
    constructor(info, textures) {
        super();
        this.delaymap = new Map();
        this.update = (dt) => {
            if (!this.visible)
                return;
            for (const x of this.children) {
                if (x instanceof InfoSprite_1.InfoSprite || x instanceof ParticleEmitter_1.ParticleEmitter) {
                    x.update(dt);
                }
            }
        };
        if (info.particles instanceof Array) {
            for (const x of info.particles) {
                const p = new ParticleEmitter_1.ParticleEmitter((textures && x.textures.map(t => textures[t])) || [], x.option);
                p.currentTime = -(x.delay || 0);
                this.delaymap.set(p, -(x.delay || 0));
                this.addChild(p);
            }
        }
        if (info.sprites instanceof Array) {
            for (const x of info.sprites) {
                const s = new InfoSprite_1.InfoSprite(x, textures);
                this.addChild(s);
            }
        }
    }
    setPosition(x, y) {
        const s = this.scale;
        for (const c of this.children) {
            if (c instanceof InfoSprite_1.InfoSprite) {
                c.position.set(x / s.x, y / s.y);
            }
            else if (c instanceof ParticleEmitter_1.ParticleEmitter) {
                c.offset = { x: x / s.x, y: y / s.y };
            }
        }
    }
    resetAnim() {
        for (const x of this.children) {
            if (x instanceof ParticleEmitter_1.ParticleEmitter) {
                x.currentTime = Utils_1.assert(this.delaymap.get(x));
                x.emitEnded = false;
                x.allEnd = false;
                x.visible = true;
                x.canEmit = true;
            }
            else if (x instanceof InfoSprite_1.InfoSprite) {
                x.resetAnim();
            }
        }
    }
    stopEmit() {
        for (const x of this.children) {
            if (x instanceof ParticleEmitter_1.ParticleEmitter) {
                x.canEmit = false;
            }
            else if (x instanceof InfoSprite_1.InfoSprite) {
                x.visible = false;
            }
        }
    }
    allAnimEnd() {
        for (const x of this.children) {
            if (x instanceof ParticleEmitter_1.ParticleEmitter) {
                if (!x.allEnd)
                    return false;
            }
            else if (x instanceof InfoSprite_1.InfoSprite) {
                if (!x.allAnimEnd())
                    return false;
            }
        }
        return true;
    }
}
exports.InfoEffect = InfoEffect;
//# sourceMappingURL=InfoEffect.js.map